/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcelVo } from './ParcelVo';
import {
    ParcelVoFromJSON,
    ParcelVoFromJSONTyped,
    ParcelVoToJSON,
    ParcelVoToJSONTyped,
} from './ParcelVo';

/**
 * 
 * @export
 * @interface ResponseParcelVo
 */
export interface ResponseParcelVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseParcelVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseParcelVo
     */
    message?: string;
    /**
     * 
     * @type {ParcelVo}
     * @memberof ResponseParcelVo
     */
    data?: ParcelVo;
}

/**
 * Check if a given object implements the ResponseParcelVo interface.
 */
export function instanceOfResponseParcelVo(value: object): value is ResponseParcelVo {
    return true;
}

export function ResponseParcelVoFromJSON(json: any): ResponseParcelVo {
    return ResponseParcelVoFromJSONTyped(json, false);
}

export function ResponseParcelVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseParcelVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ParcelVoFromJSON(json['data']),
    };
}

export function ResponseParcelVoToJSON(json: any): ResponseParcelVo {
    return ResponseParcelVoToJSONTyped(json, false);
}

export function ResponseParcelVoToJSONTyped(value?: ResponseParcelVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ParcelVoToJSON(value['data']),
    };
}

